<template>
  <div>
    <LoadingWidget v-if="loading" small />

    <transition name="fade">
      <div v-if="!loading && featuredDistricts.length">
        <div class="grey--text">Bairros mais buscados:</div>

        <div class="d-flex chip-group">
          <v-chip-group
            v-model="districtsSelecteds"
            active-class="secondary white--text"
            multiple
            column
            center
          >
            <v-chip
              class="
                text-caption text-sm-body-2 text-uppercase
                font-weight-medium
                rounded-0
                py-5
              "
              v-for="(
                { title, id }, keyDistrictsFeatureds
              ) in featuredDistricts"
              :value="id"
              :key="keyDistrictsFeatureds"
            >
              <span class="font-secondary">{{ title }} </span>
            </v-chip>
          </v-chip-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "./LoadingWidget.vue";

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    districts: [],
  }),
  created() {
    this.getDistricts();

    this.$rest("featuredDistricts").get();
  },
  computed: {
    featuredDistrictsId() {
      return this.$rest("featuredDistricts").list;
    },
    featuredDistricts() {
      return this.districts.filter(({ id }) =>
        this.featuredDistrictsId.includes(String(id))
      );
    },
    query() {
      return this.$route.query;
    },
    districtsSelecteds: {
      get() {
        return this.query.d
          ? this.query.d.split(",").map((v) => parseInt(v))
          : [];
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.d = v.join(",");
        else delete query.d;

        this.$router.push({ query });
      },
    },
  },
  methods: {
    getDistricts() {
      this.loading = true;

      const params = {
        business: this.business,
      };

      this.$rest("propertiesDistricts")
        .get({ params })
        .then((data) => (this.districts = data))
        .then(() => (this.loading = false));
    },
  },
  watch: {
    business() {
      this.getDistricts();
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>
